
import axios from 'axios';

const API_URL = process.env.API_URL;

export async function getListPlaylist(authorization) {
  const url = `${API_URL}/admin/public-playlist/list`;
  return axios({ url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getStatusPublicPlaylist(authorization) {
  const url = `${API_URL}/admin/app-setting/get-public-playlist-setting`;
  return axios({ url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function setStatusPublicPlaylist(status, authorization) {
  const url = `${API_URL}/admin/app-setting/public-playlist-setting`;
  return axios({
    url,
    method: 'post',
    data: status,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function setStatusPlaylist(status, authorization) {
  const url = `${API_URL}/admin/public-playlist/update-status`;
  return axios({
    url,
    method: 'post',
    data: status,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function reOrderPlaylist(playlist, authorization) {
  const url = `${API_URL}/admin/public-playlist/re-order`;
  return axios({
    url,
    method: 'post',
    data: playlist,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function createPlaylist(playlist, authorization) {
  const url = `${API_URL}/admin/public-playlist/create`;
  return axios({
    url,
    method: 'post',
    data: playlist,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function updatePlaylist(playlist, authorization) {
  const url = `${API_URL}/admin/public-playlist/update`;
  return axios({
    url,
    method: 'post',
    data: playlist,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function deletePlaylist(playlist, authorization) {
  const url = `${API_URL}/admin/public-playlist/delete`;
  return axios({
    url,
    method: 'post',
    data: playlist,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getGenreSong(authorization) {
  const url = `${API_URL}/admin/public-playlist/genre-list`;
  return axios({ url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListSong(filter, authorization) {
  const url = `${API_URL}/admin/public-playlist/search-song`;
  return axios({ url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getDetailPlaylist(id, authorization) {
  const url = `${API_URL}/admin/public-playlist/detail/${id}`;
  return axios({ url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}



// WEBPACK FOOTER //
// ./src/services/playlist.js